import {
  createFrontendModule,
  coreExtensionData,
} from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { compatWrapper } from '@backstage/core-compat-api';
import { makeStyles } from '@material-ui/core/styles';
import { getCompleteTableStyles } from '../components/styles/sharedStyles';

import { CustomCatalogIndexPage } from '../components/catalog/CustomCatalogIndexPage';

const useCatalogEntityPageStyles = makeStyles(theme => ({
  entity: {
    ...getCompleteTableStyles(theme),

    '& [class*="MuiToolbar-root"]': {
      padding: 0,
    },
    '& [class*="BackstageInfoCard-header"]': {
      paddingLeft: 0,
    },
    '& [class*="Component-horizontalScrollContainer"]': {
      overflow: 'auto',
    },
    '& [class*="BackstageBottomLink-root"]': {
      transition: theme.transitions.create(['background-color', 'color'], {
        duration: theme.transitions.duration.shortest,
      }),
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.text.primary,
      },
    },
    '& [class*="BackstageBottomLink-arrow"]': {
      marginLeft: theme.spacing(0.5),
    },
  },
}));

const customCatalogIndexPage = catalogPlugin
  .getExtension('page:catalog')
  .override({
    params: {
      loader: async () => compatWrapper(<CustomCatalogIndexPage />),
    },
  });

const customCatalogEntityPage = catalogPlugin
  .getExtension('page:catalog/entity')
  .override({
    factory(originalFactory, _context) {
      const originalContainer = originalFactory();
      const originalElement = originalContainer.get(
        coreExtensionData.reactElement,
      );

      const WrappedComponent = () => {
        const classes = useCatalogEntityPageStyles();
        return <div className={classes.entity}>{originalElement}</div>;
      };

      return [
        coreExtensionData.reactElement(<WrappedComponent />),
        ...Array.from(originalContainer).filter(
          item => item.id !== 'core.reactElement',
        ),
      ];
    },
  });

export const appviaCatalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [customCatalogIndexPage, customCatalogEntityPage],
});
